/**
 * Copy Templates
 * Banner message templates and token replacement
 */

import { SEARCH_COPY } from '../core/constants.js';
import { state } from '../core/state.js';
import { getSportNamesBySlugs } from '../utils/sport-utils.js';

/**
 * Replace tokens in copy templates
 * @param {string} template
 * @param {Record<string,string>} vars
 * @returns {string}
 */
export function fillCopy(template, vars = {}) {
  // TODO: Extract from original file (lines 65-68)
  if (!template) return '';
  return template.replace(/\{(\w+)\}/g, (_, key) => vars[key] ?? '');
}

/**
 * Fill copy template and add sports if available (up to 2 sports)
 * @param {string} template
 * @param {Record<string,string>} vars
 * @returns {string}
 */
export function fillCopyWithSports(template, vars = {}) {
  // TODO: Extract from original file (lines 76-105)
  let result = fillCopy(template, vars);

  // Add sports to message if available (up to 2 sports)
  if (state.sportSlug && state.sportSlug.length > 0 && state.sportSlug.length <= 2) {
    try {
      const sportNames = getSportNamesBySlugs(state.sportSlug);
      if (sportNames.length > 0) {
        const sportNamesLower = sportNames
          .map(name => (name || '').toLowerCase())
          .filter(Boolean);
        result = result.replace(/\bcamps\b/g, `${sportNamesLower.join(' and ')} camps`);
      }
    } catch (e) {
      console.warn('fillCopyWithSports: getSportNamesBySlugs not available', e);
    }
  }

  return result;
}

export { SEARCH_COPY };

console.log('📦 Copy templates module loaded');
